/** Точка на расстоянии distanceM по азимуту bearingDeg (0 = север, по часовой). */
export function destinationLngLat(
  lng: number,
  lat: number,
  bearingDeg: number,
  distanceM: number,
): { lng: number; lat: number } {
  const R = 6371000;
  const lat1 = (lat * Math.PI) / 180;
  const lng1 = (lng * Math.PI) / 180;
  const brng = (bearingDeg * Math.PI) / 180;
  const angDist = distanceM / R;
  const lat2 = Math.asin(
    Math.sin(lat1) * Math.cos(angDist) +
      Math.cos(lat1) * Math.sin(angDist) * Math.cos(brng),
  );
  const lng2 =
    lng1 +
    Math.atan2(
      Math.sin(brng) * Math.sin(angDist) * Math.cos(lat1),
      Math.cos(angDist) - Math.sin(lat1) * Math.sin(lat2),
    );
  return { lng: (lng2 * 180) / Math.PI, lat: (lat2 * 180) / Math.PI };
}
